<?php

// autoload.php @generated by Composer

require_once __DIR__ . '/composer/autoload_real.php';

return ComposerAutoloaderInita938c0f9513fc8fb70dd34967ae81190::getLoader();
